import React, { useState } from 'react';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import EditableBlock from './EditableBlock';
import { Plus } from 'lucide-react';

export default function EditorCanvas({ blocks, onBlockUpdate, onBlockDelete }) {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 min-h-[600px]">
      <div className="p-6">
        <div className="mb-4 text-sm text-gray-500">
          Drag blocks from the left panel or click to edit existing blocks
        </div>

        <SortableContext
          items={blocks?.map(b => b?.id)}
          strategy={verticalListSortingStrategy}
        >
          <div className="space-y-4">
            {blocks?.map((block) => (
              <EditableBlock
                key={block?.id}
                block={block}
                onUpdate={onBlockUpdate}
                onDelete={onBlockDelete}
              />
            ))}
          </div>
        </SortableContext>

        {blocks?.length === 0 && (
          <div className="flex items-center justify-center h-96 border-2 border-dashed border-gray-300 rounded-lg">
            <div className="text-center">
              <Plus className="w-12 h-12 text-gray-400 mx-auto mb-3" />
              <p className="text-sm text-gray-500 font-medium">
                Drag blocks here to build your template
              </p>
              <p className="text-xs text-gray-400 mt-1">
                Start by dragging a header or text block
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}